import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';
import { FillerEntrySchema } from './filler.validator';

export const ProductFillerEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    filler: FillerEntrySchema.optional().nullable(),
    percentage: z.number().optional()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
